import { useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { Button } from 'Components/LegacyButton';

import {
  arePreviewProductsInFeatured,
  arePreviewProductsInOptional,
  arePreviewProductsInUpsale,
} from 'dux/checkoutCart/selectors';
import {
  getHasUnansweredQuestions,
  getProductsWithUnansweredQuestionsList,
} from 'dux/user/selectors';

import { PreviewSection } from './PreviewSection';
import ProductPreviewAtCart from './ProductPreviewAtCart';
import StyledCartSection from './StyledCartSection';

const CartSection = ({
  children,
  hasUnansweredQuestions,
  products,
  elligibleToPreviewInSection,
  productsWithUnansweredQuestionsList,
}) => {
  const showPreview = elligibleToPreviewInSection && hasUnansweredQuestions;

  const shouldProductBeShownInPreview = products.some(p =>
    productsWithUnansweredQuestionsList.includes(p.type)
  );
  if (showPreview && shouldProductBeShownInPreview) {
    return <PreviewSection products={products} />;
  }
  return <StyledCartSection>{children}</StyledCartSection>;
};

CartSection.propTypes = {
  children: PropTypes.node,
  hasUnansweredQuestions: PropTypes.bool,
  products: PropTypes.arrayOf(PropTypes.shape({})),
  elligibleToPreviewInSection: PropTypes.bool.isRequired,
  productsWithUnansweredQuestionsList: PropTypes.arrayOf(PropTypes.string),
};

CartSection.defaultProps = {
  children: null,
  hasUnansweredQuestions: false,
  products: [],
  productsWithUnansweredQuestionsList: [],
};

export const UpsaleSection = connect(
  state => ({
    hasUnansweredQuestions: getHasUnansweredQuestions(state),
    elligibleToPreviewInSection: arePreviewProductsInUpsale(state),
    productsWithUnansweredQuestionsList: getProductsWithUnansweredQuestionsList(state),
  }),
  {}
)(CartSection);

export const FeaturedSection = connect(
  state => ({
    hasUnansweredQuestions: getHasUnansweredQuestions(state),
    elligibleToPreviewInSection: arePreviewProductsInFeatured(state),
    productsWithUnansweredQuestionsList: getProductsWithUnansweredQuestionsList(state),
  }),
  {}
)(CartSection);

const Header = () => null;
const Body = () => null;

const OtherSection = ({
  children,
  hasUnansweredQuestions,
  products,
  elligibleToPreviewInSection,
  productsWithUnansweredQuestionsList,
}) => {
  const [isOptionalOpen, setOptionalOpen] = useState(false);

  const showPreview = elligibleToPreviewInSection && hasUnansweredQuestions;
  // Vue-like slots
  const header = children.find(el => el.type === Header);
  const body = children.find(el => el.type === Body);

  const onlyPreviewProducts = products.filter(p =>
    productsWithUnansweredQuestionsList.includes(p.type)
  );

  return (
    <StyledCartSection optional>
      {header?.props?.children}
      {!isOptionalOpen && (
        /**
         * For a11y the see more button should be before the collapsible content
         * so it enables continuouslly tab into the see more cards
         */
        <Button
          data-click="see-more"
          onClick={() => setOptionalOpen(true)}
          type="button"
          variant="underlined"
        >
          See more
        </Button>
      )}
      {isOptionalOpen && (
        <>
          {body ? body.props.children : null}
          {showPreview && (
            <ProductPreviewAtCart css={{ marginTop: '72px' }} products={onlyPreviewProducts} />
          )}

          <Button
            data-click="see-less"
            marginTop
            onClick={() => setOptionalOpen(false)}
            type="button"
            variant="underlined"
          >
            See less
          </Button>
        </>
      )}
    </StyledCartSection>
  );
};

OtherSection.Header = Header;
OtherSection.Body = Body;

OtherSection.propTypes = {
  children: PropTypes.node.isRequired,
  hasUnansweredQuestions: PropTypes.bool.isRequired,
  products: PropTypes.arrayOf(PropTypes.shape({})),
  elligibleToPreviewInSection: PropTypes.bool.isRequired,
  productsWithUnansweredQuestionsList: PropTypes.arrayOf(PropTypes.string).isRequired,
};

OtherSection.defaultProps = {
  products: [],
};

export const OptionalSection = connect(
  state => ({
    hasUnansweredQuestions: getHasUnansweredQuestions(state),
    elligibleToPreviewInSection: arePreviewProductsInOptional(state),
    productsWithUnansweredQuestionsList: getProductsWithUnansweredQuestionsList(state),
  }),
  {}
)(OtherSection);
